export const getPathQuery = (pathname, params) => {
  switch (pathname) {
    case "/home/top_search_cat_menu_apartments":
      return { category: "top_search_cat_menu_apartments" };
    case "/home/menu_houses":
      return { category: "menu_houses" };
    case "/home/menu_office":
      return { category: "menu_office" };
    case "/home/form_input_lot":
      return { category: "form_input_lot" };
    case "/home/form_input_garages":
      return { category: "form_input_garages" };
    case "/home/deleted":
      return { propertyStatus: "deleted" };
    case "/home/sold":
      return { propertyStatus: "sold" };
    case "/home/published":
      return { notPublished: true };
    case "/home/descriptionPublished":
      return { nonApprovedDescription: true };
    case "/home/propertyId":
      return { noPropertyId: true };
    case "/home/pictures":
      return { pictures: false };
    default:
      return params?.id;
  }
};
